import React, { Component } from 'react'

import './HomeOfficeSelector.scss'
import LabeledIcon from 'components/LabeledIcon'

const OFFICE = true

class HomeOfficeSelector extends Component {
  componentWillMount () {
    const { input } = this.props
    const { value, onChange } = input

    // This will toggle the correct component for selecting desks or rooms (office vs home).
    onChange(value)
  }

  render () {
    const { input } = this.props
    const { value, onChange } = input

    return (
      <div className='HomeOfficeSelector'>
        <LabeledIcon
          selected={value !== OFFICE}
          onClick={() => { onChange(false) }}
          iconType='icon'
          iconContent='home'
          label='Casa'
          />
        <LabeledIcon
          selected={value === OFFICE}
          onClick={() => { onChange(true) }}
          iconType='icon'
          iconContent='work'
          label='Oficina'
          />
      </div>
    )
  }
}

HomeOfficeSelector.displayName = 'HomeOfficeSelector'
HomeOfficeSelector.propTypes = {}
HomeOfficeSelector.defaultProps = {}

export default HomeOfficeSelector



// WEBPACK FOOTER //
// ./src/screens/App/screens/Booking/screens/ServiceSetup/screens/LocationForm/components/HomeOfficeSelector/HomeOfficeSelector.js